import { cn } from '@/shared/lib/utils'

interface EmptyStateAction {
  label: string
  onClick: () => void
  variant: 'primary' | 'ghost'
}

interface EmptyStateProps {
  icon?: React.ReactNode
  title: string
  description?: string
  action?: EmptyStateAction
  compact?: boolean
  className?: string
}

function DefaultIcon() {
  return (
    <div className="w-14 h-14 rounded-[14px] bg-paper border border-ink-border flex items-center justify-center">
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <circle cx="10" cy="13" r="2" fill="#C9A84C" />
        <path d="M10,11 A2,2 0 0,1 10,15" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" fill="none" />
        <path d="M10,8.5 A4.5,4.5 0 0,1 10,17.5" stroke="#C9A84C" strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.5" />
        <path d="M10,6 A7,7 0 0,1 10,20" stroke="#C9A84C" strokeWidth="0.8" strokeLinecap="round" fill="none" opacity="0.25" />
      </svg>
    </div>
  )
}

export function EmptyState({
  icon, title, description, action, compact = false, className,
}: EmptyStateProps) {
  return (
    <div className={cn(
      'bg-white border border-ink-border rounded-card',
      'flex flex-col items-center text-center',
      compact ? 'px-6 py-8' : 'px-8 py-14',
      className,
    )}>
      <div className="mb-4">
        {icon ?? <DefaultIcon />}
      </div>

      <h3 className="font-serif text-[15px] font-bold text-ink tracking-tight mb-2">
        {title}
      </h3>

      {description && (
        <p className="font-sans text-[12px] font-light text-ink-muted max-w-[280px] leading-relaxed mb-5">
          {description}
        </p>
      )}

      {action && (
        <button
          onClick={action.onClick}
          className={cn(
            'font-sans text-[12px] font-medium rounded-lg px-4 py-2',
            'transition-all active:scale-[0.98]',
            action.variant === 'primary'
              ? 'bg-brick hover:bg-brick-hover text-white'
              : 'bg-paper border border-ink-border text-ink hover:bg-paper-warm',
          )}
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
